const R = require("ramda");

export const devMode = process.env.NODE_ENV !== "production";

export const devOfflineMode = false;
import ModalNotification from "./components/ModalNotification";

/**
 *  replicates array_get feature from laravel
 */
export const array_get = function (i, k, d) {
  if (typeof d === "undefined") {
    d = null;
  }
  if (!k) return i;

  var s = k.split(".");

  var o = i;

  for (var x = 0; x < s.length; x++) {
    if (null !== o && typeof o !== "undefined" && o.hasOwnProperty(s[x])) {
      o = o[s[x]];
    } else {
      return d;
    }
  }

  return o;
};

export const niceDeliveryStatusName = function (status) {
  let ret;
  switch (status) {
    case "bounced":
      ret = "temporär nicht zustellbar";
      break;
    case "delivered":
      ret = "zugestellt";
      break;
    case "opened":
      ret = "Mail geöffnet";
      break;
    case "unbekannt":
      ret = "noch nie zugestellt";
      break;
    case "processed":
      ret = "in Zustellung";
      break;
    case null:
      ret = "Alle";
      break;
    case "dropped-hardfail":
      ret = "nicht zustellbar";
      break;
    case "dropped":
      ret = "nicht zustellbar";
      break;
    default:
      ret = status;
  }
  return ret;
};

export const parseErrorsFromResponse = function (res) {
  let errors = [];

  if ((res || {}).data) {
    let data = res.data;
    if ((data || {}).errors) {
      R.map(i => {
        if (typeof i === "string" || i instanceof String) {
          errors.push({
            type: "modal",
            title: "Error",
            class: "is-danger",
            text: i
          });
        } else {
          errors.push({
            type: "snackbar",
            class: "is-danger",
            text: i[0]
          });
        }
      }, data.errors);
    }
    if ((data || {}).message) {
      errors.push({
        type: "toast",
        class: "is-danger",
        text: res.message
      });
    }
  } else {
    errors.push({
      type: "toast",
      class: "is-warning",
      text: "error while sending request"
    });
  }
  return errors.length ? errors : null;
};

export const displayNotifications = function (component, notifications) {
  if (notifications !== null) {
    notifications.map(e => {
      if (e.type == "toast") {
        component.$toast.open({
          duration: 3000,
          message: e.text,
          type: e.class,
          position: "is-top",
          queue: false
        });
      } else if (e.type === "snackbar") {
        component.$snackbar.open({
          message: e.text,
          type: e.class,
          position: "is-top",
          actionText: "ok",
          indefinite: true,
          queue: true
        });
      } else if (e.type === "modal") {
        component.$modal.open({
          parent: component,
          component: ModalNotification,
          hasModalCard: true,
          props: {
            data: e
          },
          canCancel: ["outside", "escape"]
        });
      }
    });
  }
};

export const handleErrorsFromResponse = function (component, res) {
  displayNotifications(component, parseErrorsFromResponse(res));
};

export const handleNotificationsFromResponse = function (component, res) {
  displayNotifications(component, array_get(res, "data.notifications", []));
};

export const getBuefyPaginationValues = function (obj) {
  if (!obj) {
    return null;
  }

  const current = obj.page_number;
  const perPage = obj.page_size;
  const total = obj.total_entries;

  let firstItem = current * perPage - perPage + 1;
  firstItem = firstItem >= 0 ? firstItem : 0;
  let lastItem = Math.min(current * perPage, total);
  return {
    firstItem,
    lastItem,
    total
  };
};

// function trim(stringToTrim) {
//     return stringToTrim.replace(/^\s+|\s+$/g, "");
// }
// function ltrim(stringToTrim) {
//     return stringToTrim.replace(/^\s+/, "");
// }
// function rtrim(stringToTrim) {
//     return stringToTrim.replace(/\s+$/, "");
// }
